"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var Badges_1 = __importDefault(require("components/Badges/Badges"));
var Money_1 = __importDefault(require("components/Money"));
var fieldProcessors_1 = require("utils/fieldProcessors");
var PREFIX = 'SpendAndPricingPlansBadges';
var classes = {
    descriptionHeadingContainer: "".concat(PREFIX, "-descriptionHeadingContainer"),
    serviceStatAttributeLabel: "".concat(PREFIX, "-serviceStatAttributeLabel"),
    serviceStatAttributeContainer: "".concat(PREFIX, "-serviceStatAttributeContainer"),
};
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.descriptionHeadingContainer)] = {
            color: 'hsl(0,0%,30%)',
            fontWeight: 500,
        },
        _b[".".concat(classes.serviceStatAttributeLabel)] = {
            width: '140px',
            color: theme.palette.grey[600],
        },
        _b[".".concat(classes.serviceStatAttributeContainer)] = {
            display: 'flex',
            fontSize: '1rem',
            color: theme.palette.primary.main,
            fontWeight: 500,
            marginTop: '8px',
            marginBottom: '8px',
        },
        _b);
});
var SpendAndPricingPlansBadges = function (_a) {
    var serviceStat = _a.serviceStat;
    if (!(serviceStat === null || serviceStat === void 0 ? void 0 : serviceStat.calculatedAnnualSpend)) {
        return null;
    }
    var pricingPlanNames = (0, fieldProcessors_1.getPricingPlansNames)(serviceStat);
    return ((0, jsx_runtime_1.jsx)(Root, __assign({ className: (0, clsx_1.default)('d-flex', classes.descriptionHeadingContainer) }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.serviceStatAttributeContainer }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: classes.serviceStatAttributeLabel }, { children: "Your spend" })), (0, jsx_runtime_1.jsx)(Money_1.default, { amount: serviceStat.calculatedAnnualSpend }), " Last 12 Months", pricingPlanNames === null || pricingPlanNames === void 0 ? void 0 : pricingPlanNames.map(function (planName) { return ((0, jsx_runtime_1.jsx)(Badges_1.default, __assign({ className: "ml-3", color: "blue", size: "20" }, { children: planName }), planName)); })] })) })));
};
exports.default = SpendAndPricingPlansBadges;
